import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';
import UserStore from './UserStore';
import { asDate } from '../utils/Date';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];
let _classes = [];
let _myStats = [];
let _myClassesStats = [];
let _statusOptions= [];
let _typeOptions= [];
let _fetchedAll = false;

const _statuses = [
    { name: null,        id: null,        next: ['waiting', 'enrolled']    },
    { name: 'Waiting',   id: 'waiting',   next: ['waiting', 'enrolled', 'cancelled']  },
    { name: 'Enrolled',  id: 'enrolled',  next: ['enrolled', 'cancelled', 'completed'] },
    { name: 'Cancelled', id: 'cancelled', next: ['waiting', 'enrolled', 'cancelled'] },
    { name: 'Completed', id: 'completed', next: ['completed'] },
];

const sanitizeEntity = ({id, categoryId, accessLeft, accessRight, ...entity}) => ({
    ...entity,
    id: Number(id),
    categoryId: Number(categoryId) || null,
    vendorId: Number(entity.vendorId) || null,
    accessGroupId: Number(entity.accessGroupId) || null,
    emailTemplateId: Number(entity.emailTemplateId) || null,
    validFrom: asDate(entity.validFrom),
    validTo: asDate(entity.validTo),
    designatedModuleId: Number(entity.designatedModuleId) || null,
    duration: Number(entity.duration) || null,
    access: entity.accessGroupId && {
        id: Number(entity.accessGroupId),
        name: entity.accessGroup || null,
        left: accessLeft,
        right: accessRight
    }
});

const getFilter = ({skillId = null}) => e => (!!e && (e.skillId === skillId));
const getRemoveFilter = ({skillId = null}) => e => (!!e && (e.skillId !== skillId));

let CourseStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    emitChangeForm: function() {
        this.emit(FORM_CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getStatusOptions: function() {
        return _statusOptions;
    },
    getTypeOptions: function() {
        return _typeOptions;
    },
    getById: function(id) {
        id = Number(id);
        return _entities.find((e) => (e !== undefined && e.id === id) );
    },
    getByIds: (courseIds) => _entities.filter(({id}) => courseIds.includes(id)),
    getByCategory: function(categoryId) {
        categoryId = Number(categoryId);
        if (!categoryId) { return []; }
        return _entities.filter((e) => (e !== undefined && e.categoryId === categoryId) );
    },
    getBy: (filters) => _entities.filter(getFilter(filters)),

    getAll: function() {
         return _entities;
    },
    getMy: function() {
         return _entities;
    },
    getMyClasses: function() {
         return _classes;
    },
    add: function(course) {
        course = sanitizeEntity(course);
        const courseIndex = course.id && _entities.findIndex( (e) => (e !== undefined && e.id === course.id) );
        if (courseIndex < 0) {
            _entities.push(course);
        } else {
            _entities[courseIndex] = course;
        }
    },
    delete: function(id) {
        id = Number(id);
        const courseIndex = !!id && _entities.findIndex( (e) => (e !== undefined && e.id === id) );
        if (courseIndex >= 0) {
            delete _entities[courseIndex];
        }
    },
    removeUserWaitingList: function(courseId, waitingListId) {
        let course = CourseStore.getById(courseId);
        waitingListId = Number(waitingListId);
        if (!!waitingListId && course.waitingLists !== undefined && course.waitingLists.length > 0) {
            let index = course.waitingLists.findIndex((e) => (e !== undefined && e.id === waitingListId) );
            if(index >= 0) {
                delete course.waitingLists[index];
                CourseStore.add(course);
            }
        }
    },
    addUserWaitingList: function(id, userId) {
        let course = CourseStore.getById(id);
        let index = -1;

        if (course.waitingLists !== undefined && course.waitingLists.length > 0) {
            index = course.waitingLists.findIndex(function(e) {
                return e !== undefined && e.id == userId;
            });
        }
        if (index < 0) {
            let user = UserStore.getById(userId);
            course.waitingLists.push(user);
            CourseStore.add(course);
        }
    },
    getStatuses: function() {
        return _statuses.filter(function(e) {
            return e !== undefined && e.id !== null;
        }).map(function(e) {
            return {id: e.id, name: e.name };
        });
    },
    getMyStats: function() {
        return _myStats;
    },
    getMyClassesStats: function() {
        return _myClassesStats;
    },
    fetchedAll: () => (_fetchedAll)

});

CourseStore.dispatchToken = CentricDispatcher.register(function(action) {
    let course;
    switch(action.type) {

        case ActionTypes.COURSE_CLASS_LIST:
            _classes = action.data;
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_CLASS_LIST_ERROR:
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_MY_CLASS_STATS:
            _myClassesStats = action.data;
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_LIST:
            if (!!action.payload) {
                if (!!action.payload.clearAll) {
                    _entities = []; // should be only if needed
                } else if (action.payload.hasOwnProperty('skillId')) {
                    _entities = _entities.filter(getRemoveFilter(action.payload));
                }
            }
            action.data.forEach(CourseStore.add);
            _fetchedAll = action.data.length === 0;
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_LIST_ERROR:
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_INFO:
            CourseStore.add(action.data);
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_INFO_ERROR:
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_SAVE:
            CourseStore.add(action.data);
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_UPDATE:
            CourseStore.add(action.data);
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_DELETE:
            CourseStore.delete(action.data);
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_STATUS_OPTION_LIST:
            _statusOptions = action.data;
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_TYPE_OPTION_LIST:
            _typeOptions = action.data;
            CourseStore.emitChange();
            break;

        case ActionTypes.USER_COURSE_WAITINGLIST_REMOVE:
            CourseStore.removeUserWaitingList(action.data.courseId, action.data.waitingListId);
            CourseStore.emitChange();
            break;

        case ActionTypes.USER_COURSE_WAITINGLIST_ADD:
            CourseStore.addUserWaitingList(action.data.courseId, action.data.delegateId);
            CourseStore.emitChange();
            break;

        case ActionTypes.COURSE_LABEL_ADD_SUCCESS:
            course = CourseStore.getById(action.payload.id);
            if (!(course.labels.map(({id}) => Number(id)).includes(Number(action.payload.label.id)))) {
                CourseStore.add({ ...course, labels: [...course.labels, action.payload.label]});
                CourseStore.emitChange();
            }
            break;

        case ActionTypes.COURSE_LABEL_REMOVE_SUCCESS:
            course = CourseStore.getById(action.payload.id);
            CourseStore.add({
                ...course,
                labels: course.labels.filter(({id}) => Number(id) !== Number(action.payload.labelId))
            });
            CourseStore.emitChange();
            break;


        default:
            break;
    }

});

export default CourseStore;
